<template>
  <b-col cols="12">
    <b-card>
      <div slot="header">
        <div class="float-left">
          {{ $lang.azmoonLang.edit_azmoon_execute }}
          <span v-if="item.caption">({{ item.caption }})</span>
        </div>
        <div v-if="item.id" class="float-right">
          {{ $lang.azmoonLang.azmoon_execute_number }} : {{ item.id }}
        </div>
      </div>
      <div class="text-center" v-show="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <b-alert :show="centerExecuteId" variant="danger">
        <mdicon name="help-circle-outline" size="20" />
        <strong v-text="$lang.notSelectExecutePerson" class="ml-1" />
      </b-alert>
      <b-tabs v-show="!isLoading">
        <b-tab :lazy="true" active>
          <template v-slot:title>{{ $lang.azmoonLang.base_info }}</template>
          <AzmoonExecuteForm
            v-if="Object.keys(item).length > 0 && !isLoading"
            :item="item"
            @submit="save"
            @handleBack="handleBack"
            mode="edit"
            :permissions="permissionButtons"
          />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.azmoonLang.azmoon_execute_person }}
          </template>
          <b-row class="mx-0">
            <b-col>
              <SearchCard
                :filterCatch="true"
                :hasFilter="true"
                :title="$lang.azmoonLang.azmoon_execute_person"
                :url="azmoon_execute_person_url"
                :html="false"
                :allowFields="$lang.azmoonLang.azmoon_execute_person_fildes"
                ref="azmoonExecutePersonSearch"
                :permissions="permissionButtons"
                :hasAdd="permissionAddCondition"
                @handleAdd="azmoonExecuteModalAdd"
                :hasUploadExcel="permissionAddCondition"
                :uploadExcelTooltip="$lang.azmoon_persons_sample_upload"
                :extraButtons="extraButtons"
                @handleUploadExcel="showImportExcelPersonsModel"
                @getOther="getPersonOtherData"
              >
                <template slot="html" slot-scope="{ item }">
                  <b-col cols="12" md="12" class="my-1 px-0 py-1">
                    <b-row class="m-0">
                      <b-col cols="12" md="">
                        <b>متقاضی</b>
                        :
                        <ProfileBoxPopupWrapper
                          :data="item"
                          deskTopPopupClass="top-245"
                          nameClass="color-complementary"
                        />
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['person', 'parvandeh_number'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.azmoonLang.parvandeh_number }} :{{
                          item.person.parvandeh_number
                        }}
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['person', 'internal_code'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.internal_code }} :{{
                          item.person.internal_code
                        }}
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['person', 'national_code'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.national_code }} :{{
                          item.person.national_code
                        }}
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    v-if="checkByCandidate(item, 'operator')"
                    cols="12"
                    md="12"
                    class="my-1 px-0 py-1"
                  >
                    <b-row class="m-0">
                      <b-col cols="12" md="">
                        <b> اپراتور </b>:
                        <ProfileBoxPopupWrapper
                          :data="item.operator"
                          deskTopPopupClass="top-245"
                          nameClass="color-complementary"
                        />
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['operator', 'parvandeh_number'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.azmoonLang.parvandeh_number }} :{{
                          item.operator.parvandeh_number
                        }}
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['operator', 'internal_code'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.internal_code }} :{{
                          item.operator.internal_code
                        }}
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['operator', 'national_code'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.national_code }} :{{
                          item.operator.national_code
                        }}
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    v-if="checkByCandidate(item, 'reference')"
                    cols="12"
                    md="12"
                    class="my-1 px-0 py-1"
                  >
                    <b-row class="m-0">
                      <b-col cols="12" md="">
                        <b> معرف</b>:
                        <ProfileBoxPopupWrapper
                          :data="item.reference"
                          deskTopPopupClass="top-245"
                          nameClass="color-complementary"
                        />
                      </b-col>
                      <b-col cols="12" md="" class="invisible" />
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['reference', 'internal_code'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.internal_code }} :{{
                          item.reference.internal_code
                        }}
                      </b-col>
                      <b-col
                        cols="12"
                        md=""
                        :class="{
                          invisible: !pathOr(
                            null,
                            ['reference', 'national_code'],
                            item
                          ),
                        }"
                      >
                        {{ $lang.national_code }} :{{
                          item.reference.national_code
                        }}
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                    class="text-md-right text-center p-1"
                  >
                    <div class="float-left text-left info_card">
                      <span
                        class="text-primary"
                        v-b-tooltip.hover
                        :title="`${$lang.created_with}: ${pathOr(
                          '',
                          ['created_by', 'name'],
                          item
                        )} ${$lang.at}: ${pathOr(
                          '',
                          ['created_at', 'jalali'],
                          item
                        )}`"
                      >
                        <mdicon name="information" size="20" />
                      </span>
                      <b-badge
                        class="mx-1"
                        v-if="item.is_created_task"
                        variant="success"
                        >تسک ایجاد شده
                      </b-badge>
                      <b-badge class="mx-1" v-else variant="danger"
                        >تسک ایجاد نشده
                      </b-badge>
                    </div>

                    <div class="float-right">
                      <b-button
                        v-if="
                          !centerExecuteId &&
                          !isClosedAzmoon &&
                          !pathOr(0, ['is_absent', 'id'], item)
                        "
                        @click="showRemoveConfirm(item)"
                        class="m-1"
                        size="sm"
                        variant="outline-danger"
                      >
                        <mdicon name="close" size="20" class="ml-2" />
                        {{ $lang.remove }}
                      </b-button>
                      <b-button
                        v-if="
                          !isClosedAzmoon &&
                          !pathOr(0, ['is_absent', 'id'], item)
                        "
                        @click="showSetAbsentConfirm(item)"
                        class="m-1"
                        size="sm"
                        variant="outline-danger"
                      >
                        <mdicon
                          :name="
                            pathOr(0, ['is_absent', 'id'], item) === 1
                              ? 'account-clock'
                              : 'account-cancel-outline'
                          "
                          size="20"
                          class="ml-2"
                        />
                        {{
                          pathOr(0, ["is_absent", "id"], item) == 1
                            ? $lang.presence
                            : $lang.absence
                        }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        @click="handleOpenPersonContentModal(item)"
                        class="m-1"
                        size="sm"
                        variant="outline-success"
                      >
                        <mdicon
                          name="account-eye-outline"
                          size="20"
                          class="ml-2"
                        />
                        {{ $lang.show_person_content }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        @click="upShowTimeControlModal(item)"
                        class="m-1"
                        size="sm"
                        variant="outline-success"
                      >
                        <mdicon
                          name="timer-cog-outline"
                          size="20"
                          class="ml-2"
                        />
                        {{ $lang.showTimeControl }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        @click="showUploadReadyReportModal(item)"
                        class="m-1"
                        size="sm"
                        variant="outline-primary"
                      >
                        <mdicon
                          name="cloud-upload-outline"
                          size="20"
                          class="ml-2"
                        />
                        {{ $lang.upload_ready_report }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        @click="handleOpenRebuildReportModal(item)"
                        class="m-1"
                        size="sm"
                        variant="warning"
                      >
                        <mdicon name="recycle-variant" size="20" class="ml-2" />
                        {{ $lang.rebuild }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        @click="handleOpenComputeGradeModal(item)"
                        class="m-1"
                        size="sm"
                        variant="warning"
                      >
                        <mdicon
                          name="clipboard-list-outline"
                          size="20"
                          class="ml-2"
                        />
                        {{ $lang.computeGrades }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        class="m-1"
                        variant="primary"
                        size="sm"
                        @click="showReports(item)"
                      >
                        <mdicon
                          name="clipboard-list-outline"
                          size="20"
                          class="ml-2"
                        />
                        {{ $lang.reports }}
                      </b-button>
                      <b-button
                        v-if="!pathOr(0, ['is_absent', 'id'], item)"
                        @click="showAzmoonLinks(item)"
                        class="m-1"
                        size="sm"
                        variant="primary"
                      >
                        <mdicon
                          name="clipboard-list-outline"
                          size="20"
                          class="ml-2"
                        />
                        {{ $lang.exam_packs }}
                      </b-button>
                    </div>
                  </b-col>
                  <div
                    class="absent__user text-danger"
                    v-if="!!pathOr(false, ['is_absent', 'id'], item)"
                    v-text="pathOr('', ['is_absent', 'caption'], item)"
                  />
                </template>
              </SearchCard>
              <Confirm
                v-model="confirmModal"
                :title="$lang.remove_item"
                :description="confirmDescription"
                dynamicClass=""
                :loading="confirmLoading"
                :preventDefault="true"
                :cancel-title="$lang.no"
                :ok-title="$lang.yes"
                @cancel="confirmModal = false"
                @ok="removeItem"
              />
              <Confirm
                v-model="absentConfirmData.show"
                :title="absentConfirmData.title"
                :description="absentConfirmData.description"
                dynamicClass=""
                :loading="absentConfirmData.loading"
                :preventDefault="true"
                :cancel-title="$lang.no"
                :ok-title="$lang.yes"
                @cancel="absentConfirmData.show = false"
                @ok="changeAzmoonExecutePerson"
              />
              <Confirm
                v-model="confirmData.show"
                :title="confirmData.title"
                :description="confirmData.description"
                :ok-title="$lang.yes"
                :cancel-title="$lang.no"
                :loading="confirmData.loading"
                :loadingSpinnerText="$lang.updating_data"
                dynamicClass=""
                @ok="rebuildReport"
                @cancel="confirmData.show = false"
              />
              <Confirm
                v-model="confirmGradeData.show"
                :title="confirmGradeData.title"
                :description="confirmGradeData.description"
                :ok-title="$lang.yes"
                :cancel-title="$lang.no"
                :loading="confirmGradeData.loading"
                :loadingSpinnerText="$lang.updating_data"
                dynamicClass=""
                @ok="rebuildGrades"
                @cancel="confirmGradeData.show = false"
              />
              <Confirm
                v-model="rebuildReportConfirmData.show"
                :title="rebuildReportConfirmData.title"
                :description="rebuildReportConfirmData.description"
                :ok-title="$lang.yes"
                :cancel-title="$lang.no"
                :loading="rebuildReportConfirmData.loading"
                :loadingSpinnerText="$lang.updating_data"
                dynamicClass=""
                @ok="handleSingleRebuildReport"
                @cancel="handleCloseRebuildReportModal"
              />
              <Confirm
                v-model="computeGradeConfirmData.show"
                :title="computeGradeConfirmData.title"
                :description="computeGradeConfirmData.description"
                :ok-title="$lang.yes"
                :cancel-title="$lang.no"
                :loading="computeGradeConfirmData.loading"
                :loadingSpinnerText="$lang.updating_data"
                dynamicClass=""
                @ok="handleSingleComputeGrade"
                @cancel="handleCloseComputeGradeModal"
              />
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="reportsModal"
                size="xl"
                ok-only
                hide-footer
                hide-header
              >
                <ParvandehReportsList
                  :parvandehCode="reportParvandehCode"
                  :saltFileName="reportParvandehNumber"
                  :personName="reportPersonName"
                  resource="azmoon_execute"
                  :resourceCode="pathOr(null, ['code'], item)"
                  @close="reportsModal = false"
                />
              </b-modal>
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="readyReportModal"
                size="md"
                ok-only
                hide-header
                hide-footer
              >
                <ReportFormPerson
                  :title="`${$lang.upload_report_for} ${reportPersonName}`"
                  resource="azmoon_execute"
                  :resourceCode="azmoonExecuteCode"
                  :parvandehCode="parvandehCode"
                  @close="readyReportModal = false"
                />
              </b-modal>
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="view_azmoon_execute_person"
                size="xl"
                ok-only
                hide-header
              >
                <div class="text-center" v-show="isLoadingAzmoonPerson">
                  <b-spinner
                    variant="primary"
                    label="Text Centered"
                  ></b-spinner>
                </div>

                <AzmoonExecutePersonForm
                  v-show="!isLoadingAzmoonPerson"
                  ref="azmoon_execute_persons"
                  :azmoon_execute_id="id"
                />

                <template v-slot:modal-footer>
                  <b-button
                    variant="success"
                    :disabled="isLoadingAzmoonPerson"
                    v-if="isAdmin(permissionButtons, ['admin'])"
                    @click="addPersons()"
                  >
                    {{ $lang.azmoonLang.submitButton }}
                    <i class="fa fa-check"></i>
                  </b-button>

                  <b-button
                    variant="danger"
                    @click="view_azmoon_execute_person = false"
                  >
                    {{ $lang.azmoonLang.cancelButton }}
                    <i class="fa fa-ban"></i>
                  </b-button>
                </template>
              </b-modal>
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="showAzmoonLinksModal"
                size="xl"
                ok-only
                hide-header
                :ok-title="$lang.azmoonLang.close"
              >
                <AzmoonExecuteLinks
                  :azmoonExecuteId="azmoon_execute_id"
                  :personCode="person_code"
                  :operatorCode="operator_code"
                  :referenceCode="reference_code"
                />
              </b-modal>
              <b-modal
                no-close-on-backdrop
                v-model="importExcelPersonsModel"
                size="xl"
                hide-header
                hide-footer
              >
                <ShowCardUpload
                  :url="azmoonPersonsUploadExcelUrl"
                  :showAlert="azmoonPersonsExampleFileLink"
                  @closeModal="importExcelPersonsModel = false"
                  @getItems="azmoonExecutePersonGetItems"
                />
              </b-modal>
              <b-modal
                no-close-on-backdrop
                v-model="showTimeControlModal"
                size="xl"
                hide-header
              >
                <Search
                  :url="showTimeControlUrl"
                  :title="$lang.showTimeControl"
                  :allowFields="$lang.showTimeControlFields"
                  removeModalSize="xl"
                  :visibleSearch="false"
                  :visibleSettings="false"
                  :visibleExport="false"
                  :visibleFilters="false"
                  :visibleViewCount="false"
                  :visibleAdd="false"
                  :allowEdit="false"
                  :remove_item="removeShowTimeControl"
                  ref="showTimeControl"
                  :dynamicButtons="showTimeControlButtons"
                  :parentPermissions="showTimeControlPermissions"
                  @getPermisson="updateShowTimeControlPermissions"
                />
                <template #modal-footer>
                  <div class="float-left">
                    <b-button
                      variant="outline-danger"
                      @click="closeShowTimeControlModal"
                    >
                      <mdicon name="close" size="20" />
                      {{ $lang.close }}
                    </b-button>
                  </div>
                </template>
              </b-modal>
              <b-modal
                no-close-on-backdrop
                v-model="changeExtraTimeModal"
                size="sm"
                hide-header
                hide-footer
              >
                <b-card>
                  <div slot="header">
                    <b v-text="$lang.changeExtraTime" />
                  </div>
                  <LoadingSpinner
                    :loading="changeExtraTimeLoading"
                    :text="$lang.sending_data"
                  />
                  <b-row v-show="!changeExtraTimeLoading">
                    <b-col cols="12" md="12">
                      <b-form-group>
                        <requiredComponent
                          slot="label"
                          :label="`${$lang.extraTime} (${$lang.azmoonLang.minute}): `"
                          :rules="$v.extraTime.$params"
                        />
                        <b-form-input
                          v-model="$v.extraTime.$model"
                          type="number"
                          autocomplete="off"
                          :state="
                            $v.extraTime.$dirty ? !$v.extraTime.$error : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.extraTime.$dirty ? !$v.extraTime.$error : null
                          "
                        >
                          <div v-if="!$v.extraTime.required">
                            {{
                              $lang.error_required | replace($lang.extraTime)
                            }}
                          </div>
                          <div
                            v-if="
                              !$v.extraTime.minValue || !$v.extraTime.maxValue
                            "
                          >
                            {{
                              $lang.errors.between
                                | replace($lang.extraTime, 1, 360)
                            }}
                          </div>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="12" class="text-right">
                      <b-button
                        class="mr-2"
                        variant="outline-danger"
                        @click="closeChangeExtraTimeModal"
                      >
                        <mdicon name="close" size="20" />
                        {{ $lang.close }}
                      </b-button>
                      <b-button variant="success" @click="changeExtraTime">
                        <mdicon name="check" size="20" />
                        {{ $lang.submitButton }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card>
              </b-modal>
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="personContentModalData.show"
                size="xl"
                hide-header
              >
                <!-- TODO: 
              Get: v1/azmoon-execute-person/{0}/attachment
              Delete: v1/azmoon-execute-person/{0}/attachment/{1}
              زمانی که این بخش در ویو ۳ بازطراحی شد از این سرویس ها برای لیست و حذف فایل های محتوای شرکت کننده استفاده شود
              -->
                <uploadFile
                  keyServies="azmoon_execute_person"
                  :keyValue="personContentModalData.code"
                  :file_types="file_types"
                  :outButton="outButton"
                  :parentUploadFile="false"
                  :showAdd="false"
                  :title="personContentModalData.title"
                />
                <template #modal-footer>
                  <div class="float-left">
                    <b-button
                      variant="outline-danger"
                      @click="handleClosePersonContentModal"
                    >
                      <mdicon name="close" size="20" />
                      {{ $lang.close }}
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.azmoonLang.azmoon_execute_links }}
          </template>
          <DragTable
            v-if="!isLoading"
            :showAlert="pathOr(null, ['status', 'id'], item) !== 1"
            :titleAlert="$lang.exampackAlert"
            :title="$lang.azmoonLang.azmoon_execute_links"
            :url="azmoon_execute_exam_pack"
            ref="finalExapPack"
            :dynamicButtons="tabThreeButtons"
            :keyLang="`final_exam_pack_fildes`"
            :faLang="`azmoonLang`"
            :order_url="$config.azmoon.azmoon_execute_exam_packs_order"
            :keyGroup="`azmoon_execute_id`"
            order_by="order:asc"
            :permissionButtons="permissionButtons"
            :editRoute="false"
            :removeLabel="$lang.azmoonLang.exercise_remove"
            :remove_item="remove_final_exam_pack"
            :hasAdd="
              isAdmin(permissionButtons, ['admin']) &&
              pathOr(null, ['status', 'id'], item) === 1
            "
            @handleAdd="openFinalExam"
          />
          <b-modal
            no-close-on-backdrop
            variant="primary"
            header-bg-variant="primary"
            content-class="border-primary"
            v-model="view_final_exam_pack"
            size="xl"
            ok-only
            hide-header
          >
            <div class="text-center" v-show="isLoadingExamPack">
              <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>
            <AzmoonExecuteExamPackForm
              v-show="!isLoadingExamPack"
              ref="azmoon_execute_exam_packs"
              :allowShowName="false"
              :azmoon_execute_id="id"
              :term_code="pathOr(null, ['term', 'code'], item)"
            />

            <template v-slot:modal-footer>
              <b-button
                variant="success"
                v-if="isAdmin(permissionButtons, ['admin'])"
                @click="addFinalExam()"
              >
                {{ $lang.azmoonLang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>

              <b-button variant="danger" @click="view_final_exam_pack = false">
                {{ $lang.azmoonLang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </template>
          </b-modal>
          <b-modal
            v-model="showNameModal"
            no-close-on-backdrop
            hide-header
            hide-footer
          >
            <b-card>
              <div slot="header">
                <strong v-text="'ویرایش نام نمایشی'" />
              </div>
              <LoadingSpinner
                :loading="showNameLoading"
                :text="$lang.sending_data"
              />
              <ShowNameForm
                v-if="!showNameLoading && showNameModal"
                :item="examPackRow"
                :termCode="pathOr(null, ['term', 'code'], item)"
                @submit="editShowNameForm"
                @close="showNameModal = false"
              />
            </b-card>
          </b-modal>
          <b-modal
            no-close-on-backdrop
            variant="primary"
            header-bg-variant="primary"
            content-class="border-primary"
            v-model="view_sort_final_exam_pack"
            size="xl"
            ok-only
            hide-header
          >
            <SelectSearch
              :title="$lang.preExamPack"
              ref="sort_final_exam_pack"
              :allowFields="$lang.azmoonLang.sort_final_exam_pack_fildes"
              :url="azmoon_execute_exam_pack_requirements"
              v-model="sortFinalExamPackSelected"
              :limitOneSelect="true"
              @itemSelected="itemSelected"
            />
            <template v-slot:modal-footer>
              <b-button variant="danger" @click="closeSortModal">
                {{ $lang.close }}
                <mdicon name="close" size="20" />
              </b-button>
            </template>
          </b-modal>
          <b-modal
            no-close-on-backdrop
            hide-header
            hide-footer
            v-model="azmoonPersonsUploadExcelModal"
          >
            <ShowCardUpload
              :url="examPackImportAnswersUrl"
              :showAlert="examPackImportAnswersExampleFileLink"
              @closeModal="azmoonPersonsUploadExcelModal = false"
            />
            <template v-slot:modal-footer>
              <b-button
                variant="danger"
                @click="azmoonPersonsUploadExcelModal = false"
              >
                {{ $lang.close }}
                <mdicon name="close" size="20" />
              </b-button>
            </template>
          </b-modal>
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.azmoonLang.activity }}
          </template>
          <div>
            <Search
              :openCollapsed="false"
              :allowCollapse="false"
              :url="executiveActivityUrl"
              :allowFields="$lang.azmoonLang.center_execute_activity_fields"
              :hiddenFields="hiddenFieldsActivity"
              :title="$lang.azmoonLang.activity"
              config="activity"
              addModalSize="xl"
              removeModalSize="xl"
              :visibleSearch="false"
              :visibleSettings="false"
              :visibleExport="false"
              :visibleFilters="false"
              :visibleViewCount="false"
              :remove_item="remove_activity"
              :allowEdit="false"
              :dynamicButtons="tabFourButtons"
              ref="activitySearch"
              :order_by="`id:asc`"
              :dataNotExist="$lang.notRecordExist"
              :visibleAdd="isAdmin(permissionButtons, ['admin'])"
            >
              <template slot="addModal" slot-scope="search">
                <b-card>
                  <div slot="header">
                    <strong v-text="activityFormTitle" />
                  </div>
                  <LoadingSpinner
                    :loading="modalLoading"
                    :text="modalLoadingText"
                  />

                  <ActivityForm
                    v-show="!modalLoading"
                    :itemId="itemActivityId"
                    :parentId="item.code"
                    :mode="mode_activity"
                    :permissionBtn="showPermissionButton"
                    :keyAction="keyAction"
                    :keyService="keyService"
                    :keyIndex="keyAction"
                    :showUpload="true"
                    :showStateDefine="true"
                    :showRoleCombo="true"
                    :term_id="pathOr(null, ['term', 'id'], item)"
                    :term_code="pathOr(null, ['term', 'code'], item)"
                    @submit="submit"
                    @cancel="search.close"
                    @setResponseCode="setResponseCode"
                  />
                </b-card>
              </template>
            </Search>
            <b-modal
              no-close-on-backdrop
              variant="primary"
              header-bg-variant="primary"
              content-class="border-primary"
              v-model="view_activity"
              size="xl"
              ok-only
              hide-footer
              hide-header
            >
              <b-card>
                <div slot="header">
                  <strong v-text="activityFormTitle" />
                </div>
                <LoadingSpinner
                  :loading="modalLoading"
                  :text="modalLoadingText"
                />
                <ActivityForm
                  v-show="!modalLoading"
                  :itemId="itemActivityId"
                  :parentId="item.code"
                  :mode="mode_activity"
                  :permissionBtn="showPermissionButton"
                  :keyAction="keyAction"
                  :keyService="keyService"
                  :keyIndex="keyAction"
                  :showUpload="true"
                  :showStateDefine="true"
                  :showRoleCombo="true"
                  :term_id="pathOr(null, ['term', 'id'], item)"
                  :term_code="pathOr(null, ['term', 'code'], item)"
                  @submit="submit"
                  @cancel="chancelActivity"
                  @setResponseCode="setResponseCode"
                />
              </b-card>
            </b-modal>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-col>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import DragTable from "@/components/base/dragTable";
import uploadFile from "@/components/base/uploadFile";
import AzmoonExecuteForm from "./../from/azmoonExecuteForm";
import ShowNameForm from "./../from/ShowNameForm";
import AzmoonExecutePersonForm from "./../from/AzmoonExecutePersonForm";
import AzmoonExecuteExamPackForm from "./../from/AzmoonExecuteExamPackForm";
import AzmoonExecuteLinks from "@/components/global/AzmoonExecuteLinks";
import Search from "@/components/base/search";
import SelectSearch from "@/components/base/selectSearch";
import ActivityForm from "@/components/base/ActivityForm";
import SearchCard from "@/components/base/searchCard";
import Confirm from "@/components/base/confirm";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import ReportFormPerson from "@/components/global/ReportFormPerson";
import ParvandehReportsList from "@/components/global/ParvandehReportsList";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, goToRoute } from "@/shared/utils";

export default {
  name: "edit-azmoon-execute",
  components: {
    AzmoonExecuteForm,
    ShowNameForm,
    AzmoonExecutePersonForm,
    Search,
    SelectSearch,
    ActivityForm,
    DragTable,
    AzmoonExecuteExamPackForm,
    AzmoonExecuteLinks,
    SearchCard,
    LoadingSpinner,
    Confirm,
    ShowCardUpload,
    ReportFormPerson,
    ParvandehReportsList,
    ProfileBoxPopupWrapper,
    uploadFile,
  },
  inject: [
    "azmoonExecuteRepository",
    "azmoonExecutePersonRepository",
    "azmoonExecuteExamPackRepository",
    "attachmentTempFinalRepository",
  ],
  validations: {
    extraTime: {
      required,
      minValue: minValue(-360),
      maxValue: maxValue(360),
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      permissionButtons: [],
      person_url: null,
      finalExamPackSelected: [],
      sortFinalExamPackSelected: [],
      isLoadingExamPack: false,
      isLoading: false,
      view_azmoon_execute_person: false,
      item: {},
      itemSortSelected: {},
      view_final_exam_pack: false,
      view_sort_final_exam_pack: false,
      allowPermissions: ["admin", "edit"],
      showPermissionButton: false,
      view_activity: false,
      hiddenFieldsActivity: [
        "diff_time_checkpoint",
        "text",
        "time_checkpoint",
        "start_at_period",
        "start_at_time",
        "description",
      ],
      isLoadingAzmoonPerson: false,
      showAzmoonLinksModal: false,
      azmoon_execute_id: null,
      person_code: null,
      operator_code: null,
      reference_code: null,
      mode_activity: "add",
      responseCode: [],
      modalLoading: false,
      modalLoadingText: this.$lang.receiving_data,
      keyAction: "azmoon_execute",
      keyService: "activity",
      confirmDescription: this.$lang.are_you_sure_to_remove_item,
      confirmModal: false,
      confirmLoading: false,
      itemId: null,
      itemActivityId: null,
      importExcelPersonsModel: false,
      examPackRow: null,
      showNameModal: false,
      showNameLoading: false,
      readyReportModal: false,
      parvandehCode: null,
      reportParvandehNumber: null,
      azmoonExecuteCode: null,
      confirmData: {
        loading: false,
        show: false,
        title: this.$lang.rebuildReportsForAllCandidates,
        description: this.$lang.report_message,
      },
      confirmGradeData: {
        loading: false,
        show: false,
        title: this.$lang.rebuildGradesForAllCandidates,
        description: this.$lang.grade_message,
      },
      reportsModal: false,
      reportParvandehCode: null,
      reportPersonName: "",
      personOtherData: null,
      showTimeControlModal: false,
      azmoonExecutePersonCode: null,
      showTimeControlPermissions: [],
      showTimeControlButtons: [
        {
          name: "showTimeControl",
          click: this.showChangeExtraTimeModal,
        },
        {
          name: "delete",
        },
      ],
      changeExtraTimeModal: null,
      changeExtraTimeLoading: false,
      extraTime: null,
      azmoonPersonsUploadExcelModal: false,
      currentExamPackId: null,
      rebuildReportConfirmData: {
        loading: false,
        show: false,
        title: "",
        description: this.$lang.report_message,
        currentItem: null,
      },
      computeGradeConfirmData: {
        loading: false,
        show: false,
        title: "",
        description: this.$lang.grade_message,
        currentItem: null,
      },
      absentConfirmData: {
        loading: false,
        show: false,
        title: this.$lang.setAbsent,
        description: this.$lang.setAbsentConfirmMessage,
        currentItem: null,
      },
      personContentModalData: {
        show: false,
        title: "",
        code: null,
      },
      file_types: ["image", "office", "media", "other"],
      outButton: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "2",
          name: "crop",
        },
        {
          id: "1",
          name: "download",
          href: true,
        },
      ],
    };
  },
  computed: {
    permissionAddCondition() {
      const statusId = pathOr(null, ["status", "id"], this.item);
      const centerExecuteId = pathOr(null, ["center_execute_id"], this.item);
      return includes(statusId, [1, 2]) && !centerExecuteId;
    },
    centerExecuteId() {
      return pathOr(null, ["center_execute_id"], this.item);
    },
    executiveActivityUrl() {
      return generateApiUrl(
        ["azmoon", "activity"],
        [this.keyAction, this.item.code]
      );
    },
    azmoon_execute_person_url() {
      return generateApiUrl(["azmoon", "azmoon_execute_id_person"], [this.id]);
    },
    final_exam_pack_url() {
      return generateApiUrl(["azmoon", "exam_pack"]);
    },
    azmoon_execute_person() {
      return generateApiUrl(["azmoon", "azmoon_execute_person"]);
    },
    azmoon_execute_person_parvandeh_url() {
      return generateApiUrl(
        ["azmoon", "azmoon_execute_person_parvandeh"],
        [this.id]
      );
    },
    azmoon_execute_exam_pack() {
      return generateApiUrl(["azmoon", "azmoon_execute_exam_pack"], [this.id]);
    },
    azmoon_execute_exam_pack_requirements() {
      const examPackId = pathOr(null, ["id"], this.itemSortSelected);
      const requirement_id = pathOr(
        null,
        ["exam_pack_requirement", "id"],
        this.itemSortSelected
      );
      const queryString = requirement_id ? { requirement_id } : {};
      return generateApiUrl(
        ["azmoon", "azmoon_execute_exam_pack_requirements"],
        [this.id, examPackId],
        queryString
      );
    },
    activityFormTitle() {
      return this.mode_activity === "add"
        ? this.$lang.addActivity
        : this.$lang.editActivity;
    },
    azmoonPersonsUploadExcelUrl() {
      return generateApiUrl(
        ["azmoon", "azmoon_execute_import_person"],
        [+this.id]
      );
    },
    azmoonPersonsExampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_Azmoon_execute_person.xlsx`;
      return `<div class='text-center font-weight-bold'>
      <p>${this.$lang.import_azmoon_persons_sample_download}</p>
      <a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
    isClosedAzmoon() {
      return pathOr(null, ["status", "id"], this.item) === 3;
    },
    extraButtons() {
      return [
        {
          name: "computeGrades",
          condition: true,
          title: this.$lang.rebuildGradesForAllCandidates,
          click: this.showGradeConfrim,
          iconName: "clipboard-list-outline",
        },
        {
          name: "rebuildReport",
          condition: true,
          title: this.$lang.rebuildReportsForAllCandidates,
          click: this.showConfirm,
          iconName: "recycle-variant",
        },
      ];
    },
    showTimeControlUrl() {
      return generateApiUrl(
        ["azmoon", "azmoon_execute_person_show_time_control"],
        [this.azmoonExecutePersonCode]
      );
    },

    examPackImportAnswersUrl() {
      return generateApiUrl(
        ["azmoon", "exam_pack_import_answers"],
        [+this.id, this.currentExamPackId]
      );
    },
    examPackImportAnswersExampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_azmoon_data.xlsx`;
      return `<div class='text-center font-weight-bold'>
      <p>${this.$lang.import_azmoon_persons_sample_download}</p>
      <a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  async created() {
    await this.fetchData();
    this.PermissionButtons();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    goToRoute,
    tabThreeButtons() {
      const allowButtons = [
        {
          name: "edit",
          click: this.editShowNameModal,
          allowStatus: [1],
        },
        {
          name: "selectPreExamPack",
          click: this.selectPreExamPack,
          allowStatus: [1],
        },
        {
          name: "examPackImportAnswers",
          click: this.showExamPackImportAnswers,
        },
        {
          name: "delete",
          allowStatus: [1],
        },
        {
          name: "enable",
          click: this.showEnableConfirm,
        },
      ];

      const statusId = pathOr(null, ["status", "id"], this.item);
      return allowButtons.filter((button) => {
        const allowStatus = pathOr(false, ["allowStatus"], button);
        return allowStatus ? includes(statusId, allowStatus) : true;
      });
    },
    editShowNameModal(item) {
      this.examPackRow = item;
      this.showNameModal = true;
    },
    async editShowNameForm(payload) {
      try {
        this.showNameLoading = true;
        const examPackId = pathOr(null, ["id"], this.examPackRow);
        const url = generateApiUrl(
          ["azmoon", "azmoon_execute_exam_pack_show_name"],
          [this.id, examPackId]
        );
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.$refs.finalExapPack.fetchData();
        this.showNameModal = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.showNameLoading = false;
      }
    },
    tabFourButtons() {
      const allowButtons = [
        {
          id: "0",
          name: "edit",
          click: this.changeCenterExecuteActivity,
        },
        {
          id: "1",
          name: "delete",
        },
        {
          id: "2",
          name: "view",
          click: this.changeCenterExecuteActivity,
        },
      ];
      const buttons = {
        1: [
          ...allowButtons.filter((button) =>
            includes(button.name, ["delete", "view", "edit"])
          ),
        ],
        2: [
          ...allowButtons.filter((button) =>
            includes(button.name, ["view", "edit"])
          ),
        ],
        3: [
          ...allowButtons.filter((button) => includes(button.name, ["view"])),
        ],
      };

      const key = pathOr(null, ["status", "id"], this.item);
      return pathOr([], [key], buttons);
    },
    showAzmoonLinks(item) {
      this.azmoon_execute_id = pathOr(
        null,
        ["azmoon_execute", "id"],
        this.personOtherData
      );
      this.person_code = pathOr(null, ["person", "parvandeh_code"], item);
      this.operator_code = pathOr(null, ["operator", "parvandeh_code"], item);
      this.reference_code = pathOr(null, ["reference", "code"], item);
      this.showAzmoonLinksModal = true;
    },
    getAzmoonExecutePersonParams(params) {
      this.AzmoonExecutePersonParams = params;
    },
    PermissionButtons() {
      this.permissionButtons.map((x) => {
        if (this.allowPermissions.includes(x)) {
          this.showPermissionButton = true;
        }
      });
    },
    remove_activity(item) {
      const url = generateApiUrl(
        ["azmoon", "activity_id"],
        [this.keyAction, this.item.code, item.id]
      );
      return this.$httpService
        .delete(url)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((error) => {
          this.$generateError(error);
          throw "error";
        });
    },
    showRemoveConfirm(item) {
      this.itemId = pathOr(null, ["azmoon_execute_person_code"], item);
      this.confirmModal = true;
    },
    async removeItem() {
      try {
        this.confirmLoading = true;
        const url = generateApiUrl(
          ["azmoon", "azmoon_execute_person_id"],
          [this.itemId]
        );
        const response = await this.$httpService.delete(url);
        this.$refs.azmoonExecutePersonSearch.getItems();
        this.$notify.success(response.data.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmLoading = false;
        this.confirmModal = false;
      }
    },
    changeCenterExecuteActivity(item) {
      this.itemActivityId = pathOr(null, ["id"], item);
      this.mode_activity = "edit";
      this.view_activity = true;
    },
    chancelActivity() {
      this.mode_activity = "add";
      this.view_activity = false;
      this.itemActivityId = null;
    },
    async submit(payload, allowAddAttachmentCode = true) {
      try {
        this.modalLoadingText = this.$lang.sending_data;
        this.modalLoading = true;
        let response = null;
        if (this.mode_activity === "add") {
          if (this.responseCode.length > 0 && allowAddAttachmentCode) {
            payload.files = this.responseCode.map(({ code }) => {
              return {
                code,
                attachment_type_id: 41,
                attachment_type_name: "attachment_type_activity",
              };
            });
          }
          response = await this.$httpService.post(
            this.executiveActivityUrl,
            payload
          );
        } else {
          const url = generateApiUrl(
            ["azmoon", "activity_id"],
            [this.keyAction, this.item.code, this.itemActivityId]
          );
          response = await this.$httpService.put(url, payload);
        }
        this.$notify.success(response.data.message);
        this.responseCode = [];
        if (this.mode_activity === "add") {
          this.$refs.activitySearch.handleAddModal();
        }
        this.$refs.activitySearch.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.modalLoading = false;
        this.view_activity = false;
      }
    },
    setResponseCode(code) {
      this.responseCode = code;
    },
    async itemSelected(item, event) {
      try {
        const examPackId = pathOr(null, ["id"], this.itemSortSelected);
        const url = generateApiUrl(
          ["azmoon", "azmoon_execute_exam_pack_requirement"],
          [this.id, examPackId]
        );
        const payload = { requirement_id: pathOr(null, ["id"], item) };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    closeSortModal() {
      this.view_sort_final_exam_pack = false;
    },
    selectPreExamPack(item) {
      this.itemSortSelected = item;
      this.view_sort_final_exam_pack = true;
    },
    async addFinalExam() {
      try {
        this.isLoadingExamPack = true;
        this.$refs.azmoon_execute_exam_packs.$v.$touch();
        if (this.$refs.azmoon_execute_exam_packs.$v.$anyError) {
          return;
        }
        let exam_packs = this.$refs.azmoon_execute_exam_packs.items.map(
          (item) => {
            let output = {
              id: item.exam_pack.id,
            };

            if (item.azmoon_term_state_selected) {
              output.term_state_id = item.azmoon_term_state_selected.value;
            }
            return output;
          }
        );
        let payload = {
          exam_packs: exam_packs,
        };
        const response = await this.azmoonExecuteExamPackRepository.create(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.$refs.finalExapPack.fetchData();
        this.view_final_exam_pack = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoadingExamPack = false;
      }
    },
    showSetAbsentConfirm(item) {
      this.absentConfirmData.show = true;
      this.absentConfirmData.currentItem = item;
    },
    async changeAzmoonExecutePerson() {
      try {
        this.absentConfirmData.loading = true;
        const azmoonExecutePersonCode = pathOr(
          null,
          ["azmoon_execute_person_code"],
          this.absentConfirmData.currentItem
        );

        const url = generateApiUrl(
          ["azmoon", "azmoonExecutePersonSetAbsent"],
          [azmoonExecutePersonCode]
        );

        const isAbsent = pathOr(
          0,
          ["is_absent", "id"],
          this.absentConfirmData.currentItem
        );
        const payload = { is_absent: +!isAbsent };

        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.$refs.azmoonExecutePersonSearch.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.absentConfirmData.loading = false;
        this.absentConfirmData.show = false;
      }
    },
    async remove_final_exam_pack(item) {
      try {
        const result = await this.azmoonExecuteExamPackRepository.delete(
          this.id,
          item.id
        );
        this.$notify.success(result.data.message);
        return true;
      } catch (error) {
        this.$generateError(error);
        return false;
      }
    },
    async openFinalExam() {
      this.view_final_exam_pack = true;
      const data = pathOr([], ["items", "result"], this.$refs.finalExapPack);
      this.finalExamPackSelected = data.map((x) => {
        return {
          id: x.id,
        };
      });
    },
    async addPersons() {
      try {
        this.isLoadingAzmoonPerson = true;
        this.$refs.azmoon_execute_persons.$v.$touch();
        if (this.$refs.azmoon_execute_persons.$v.$anyError) {
          return;
        }
        const items = this.$refs.azmoon_execute_persons.items;
        const persons = items.map((item) => {
          let out = {
            person_parvandeh_code: item.person.id,
          };
          if (item.operator) {
            out.operator_parvandeh_code = item.operator.id;
          }
          if (item.reference) {
            out.reference_code = item.reference.id;
          }
          return out;
        });
        const payload = { persons };
        const response = await this.azmoonExecutePersonRepository.create(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.view_azmoon_execute_person = false;
        this.$refs.azmoonExecutePersonSearch.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoadingAzmoonPerson = false;
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await this.azmoonExecuteRepository.find(this.id);
        this.item = pathOr([], ["data", "data"], response);
        this.permissionButtons = response.data.permissions;
        this.person_url = generateApiUrl(
          ["azmoon", "available_person"],
          [this.id]
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async remove_azmoon_execute_person(item) {
      try {
        const result = await this.azmoonExecutePersonRepository.delete(item.id);
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    azmoonExecuteModalAdd() {
      this.view_azmoon_execute_person = !this.view_azmoon_execute_person;
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1 ? this.$router.go(-1) : window.close();
      }
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const response = await this.azmoonExecuteRepository.edit(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        await this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    goToProfile(item) {},
    azmoonExecutePersonGetItems() {
      this.$refs.azmoonExecutePersonSearch.getItems();
    },
    showImportExcelPersonsModel() {
      this.importExcelPersonsModel = true;
    },
    showUploadReadyReportModal(item) {
      this.parvandehCode = pathOr(null, ["person", "parvandeh_code"], item);
      this.azmoonExecuteCode = pathOr(
        null,
        ["azmoon_execute", "code"],
        this.personOtherData
      );
      this.reportPersonName = pathOr(null, ["person", "name"], item);
      this.readyReportModal = true;
    },
    upShowTimeControlModal(item) {
      this.azmoonExecutePersonCode = pathOr(
        null,
        ["azmoon_execute_person_code"],
        item
      );
      this.showTimeControlModal = true;
    },
    closeShowTimeControlModal() {
      this.azmoonExecutePersonCode = null;
      this.showTimeControlModal = false;
    },
    showChangeExtraTimeModal(item) {
      this.changeExtraTimeId = pathOr(null, ["id"], item);
      this.extraTime = pathOr(null, ["extra_time"], item);
      this.changeExtraTimeModal = true;
    },
    closeChangeExtraTimeModal() {
      this.changeExtraTimeId = null;
      this.changeExtraTimeModal = false;
    },
    updateShowTimeControlPermissions(permissions) {
      this.showTimeControlPermissions = permissions;
    },
    async removeShowTimeControl(item) {
      try {
        const id = pathOr(null, ["id"], item);
        const url = generateApiUrl(["azmoon", "azmoon_execute_time_id"], [id]);
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.$refs.showTimeControl.getItems();
      } catch (error) {
        this.$generateError(error);
      }
    },
    async changeExtraTime() {
      this.$v.$touch();
      if (this.$v.$error) return;
      try {
        this.changeExtraTimeLoading = true;
        const url = generateApiUrl(
          ["azmoon", "azmoon_execute_time_id"],
          [this.changeExtraTimeId]
        );
        const payload = { extra_time: this.extraTime };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeChangeExtraTimeModal();
        this.$refs.showTimeControl.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeExtraTimeLoading = false;
      }
    },
    checkByCandidate(item, type) {
      const otherNationalCode = pathOr(null, [type, "national_code"], item);
      const personNationalCode = pathOr(
        null,
        ["person", "national_code"],
        item
      );
      return otherNationalCode !== personNationalCode;
    },
    showConfirm() {
      this.confirmData.show = true;
    },
    showGradeConfrim() {
      this.confirmGradeData.show = true;
    },
    async rebuildReport() {
      try {
        this.confirmData.loading = true;
        const code = pathOr(null, ["code"], this.item);
        const url = generateApiUrl(["azmoon", "rebuildReport"]);
        const payload = {
          resource: "azmoon_execute",
          resource_code: code,
          report_name: "azmoon_person",
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.confirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    async rebuildGrades() {
      try {
        this.confirmGradeData.loading = true;
        const code = pathOr(null, ["code"], this.item);
        const url = generateApiUrl(["azmoon", "rebuildReport"]);
        const payload = {
          resource: "azmoon_execute",
          resource_code: code,
          report_name: "azmoon_score",
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.confirmGradeData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmGradeData.loading = false;
      }
    },
    showReports(item) {
      this.reportParvandehCode = pathOr(
        null,
        ["person", "parvandeh_code"],
        item
      );
      this.reportPersonName = pathOr(null, ["person", "name"], item);
      this.reportParvandehNumber = pathOr(
        null,
        ["person", "parvandeh_number"],
        item
      );
      this.reportsModal = true;
    },
    getPersonOtherData(data) {
      this.personOtherData = data;
    },
    handleOpenPersonContentModal(item) {
      const code = pathOr(null, ["azmoon_execute_person_code"], item);
      if (code) {
        const fullName = pathOr(null, ["person", "name"], item);
        this.personContentModalData.code = code;
        this.personContentModalData.title = `${this.$lang.showContent} ${fullName}`;
        this.personContentModalData.show = true;
      }
    },
    handleClosePersonContentModal() {
      this.personContentModalData.show = false;
      this.personContentModalData.code = null;
    },
    showExamPackImportAnswers(item) {
      this.currentExamPackId = pathOr(null, ["id"], item);
      this.azmoonPersonsUploadExcelModal = true;
    },
    generateCandidateData(item) {
      const code = pathOr(null, ["code"], item);
      const personCode = pathOr(null, ["person", "code"], item);
      const parvandehCode = pathOr(null, ["person", "parvandeh_code"], item);
      const avatar = pathOr("", ["image_address"], item);
      const fullName = pathOr("", ["person", "name"], item);
      const mobile = pathOr("", ["person", "mobile"], item);

      return {
        code,
        personCode,
        parvandehCode,
        avatar,
        fullName,
        mobile,
      };
    },
    handleOpenRebuildReportModal(item) {
      this.rebuildReportConfirmData.currentItem = item;
      const preTitle = this.$lang.rebuildReportsFor;
      const name = pathOr("", ["person", "name"], item);
      this.rebuildReportConfirmData.title = `${preTitle} ${name}`;
      this.rebuildReportConfirmData.show = true;
    },
    handleOpenComputeGradeModal(item) {
      this.computeGradeConfirmData.currentItem = item;
      const preTitle = this.$lang.computeGradeFor;
      const name = pathOr("", ["person", "name"], item);
      this.computeGradeConfirmData.title = `${preTitle} ${name}`;
      this.computeGradeConfirmData.show = true;
    },
    handleCloseComputeGradeModal() {
      this.computeGradeConfirmData.currentItem = null;
      this.computeGradeConfirmData.show = false;
    },
    handleCloseRebuildReportModal(item) {
      this.rebuildReportConfirmData.currentItem = null;
      this.rebuildReportConfirmData.show = false;
    },
    async handleSingleRebuildReport() {
      try {
        this.rebuildReportConfirmData.loading = true;
        const azmoonExecuteCode = pathOr(
          null,
          ["azmoon_execute", "code"],
          this.personOtherData
        );
        const azmoonExecutePersonCode = pathOr(
          null,
          ["azmoon_execute_person_code"],
          this.rebuildReportConfirmData.currentItem
        );
        const url = generateApiUrl(["azmoon", "rebuildReport"]);
        const payload = {
          resource: "azmoon_execute",
          resource_code: azmoonExecuteCode,
          azmoon_execute_person_code: azmoonExecutePersonCode,
          report_name: "azmoon_person",
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.rebuildReportConfirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.rebuildReportConfirmData.loading = false;
      }
    },

    async handleSingleComputeGrade() {
      try {
        this.computeGradeConfirmData.loading = true;
        const azmoonExecuteCode = pathOr(
          null,
          ["azmoon_execute", "code"],
          this.personOtherData
        );
        const azmoonExecutePersonCode = pathOr(
          null,
          ["azmoon_execute_person_code"],
          this.computeGradeConfirmData.currentItem
        );
        const url = generateApiUrl(["azmoon", "rebuildReport"]);
        const payload = {
          resource: "azmoon_execute",
          resource_code: azmoonExecuteCode,
          azmoon_execute_person_code: azmoonExecutePersonCode,
          report_name: "azmoon_score",
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.computeGradeConfirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.computeGradeConfirmData.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.info_card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
}
</style>
